import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import backgroundSwirlLight from '../../assets/ODP_BG_Light.svg';
import backgroundSwirlDark from '../../assets/ODP_BG_Dark.svg';

export function AuroraBackground() {
  const theme = useTheme();
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: { xs: '100%', md: '70%' },
        height: { xs: 700, md: 1100 },
        backgroundImage: `url(${
          theme.palette.mode === 'dark'
            ? backgroundSwirlDark
            : backgroundSwirlLight
        })`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right top',
        backgroundSize: 'contain',
        opacity: theme.palette.mode === 'dark' ? 0.6 : 0.5,
        pointerEvents: 'none',
        zIndex: 0,
      }}
    />
  );
}
